var _rect, _circle, _circle2, _path, _circle3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChip5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    rx: 38,
    fill: "url(#paint0_linear_1605_4092)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 34.5,
    stroke: "white",
    strokeWidth: 7,
    strokeMiterlimit: 2.16568,
    strokeDasharray: "15 10"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 25.5,
    fill: "black",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7461 35.791C38.5312 35.791 39.2285 35.9404 39.8379 36.2393C40.4531 36.5381 40.9365 36.9775 41.2881 37.5576C41.6396 38.1377 41.8154 38.8525 41.8154 39.7021C41.8154 40.6279 41.6221 41.4277 41.2354 42.1016C40.8545 42.7695 40.2832 43.2822 39.5215 43.6396C38.7656 43.9971 37.8223 44.1758 36.6914 44.1758C36.0176 44.1758 35.3818 44.1172 34.7842 44C34.1924 43.8887 33.6738 43.7158 33.2285 43.4814V41.1348C33.6738 41.3691 34.207 41.5684 34.8281 41.7324C35.4551 41.8906 36.0439 41.9697 36.5947 41.9697C37.1338 41.9697 37.5879 41.8994 37.957 41.7588C38.3262 41.6123 38.6045 41.3896 38.792 41.0908C38.9854 40.7861 39.082 40.3994 39.082 39.9307C39.082 39.3037 38.8711 38.8232 38.4492 38.4893C38.0273 38.1553 37.3799 37.9883 36.5068 37.9883C36.1729 37.9883 35.8242 38.0205 35.4609 38.085C35.1035 38.1494 34.8047 38.2139 34.5645 38.2783L33.4834 37.6982L33.9668 31.1504H40.9365V33.4531H36.3486L36.1113 35.9756C36.3105 35.9346 36.5273 35.8936 36.7617 35.8525C36.9961 35.8115 37.3242 35.791 37.7461 35.791Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 20,
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1605_4092",
    x1: 38,
    y1: 0,
    x2: 38,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.645138,
    stopColor: "#1235B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip5);
export default __webpack_public_path__ + "static/media/chip5.224683130857310cb1b7a4bf0a6e909d.svg";
export { ForwardRef as ReactComponent };